export default __webpack_public_path__ + "static/badge-color-light-66055f275423bed6826802b47af1963a1584465bc006ca4180cc422dc9a551be.png";